// extracted by mini-css-extract-plugin
export default {"register-form":"Register_register-form__xhS9c","register-btn":"Register_register-btn__B8Ks-"};